import React, { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // Recupera os dados do localStorage (se existirem) ao inicializar o estado
  const [companies, setCompanies] = useState(() => {
    const storedCompanies = localStorage.getItem('companies');
    return storedCompanies ? JSON.parse(storedCompanies) : [];
  });

  const [accessKey, setAccessKey] = useState(() => {
    return localStorage.getItem('accessKey') || '';
  });

  const [selectedCompany, setSelectedCompany] = useState(() => {
    return localStorage.getItem('selectedCompany') ? parseInt(localStorage.getItem('selectedCompany')) : 0;
  });

  const [codassinante, setCodAssinante] = useState(() => {
    return localStorage.getItem('codassinante') ? parseInt(localStorage.getItem('codassinante')) : 0;
  });

  const [codcolaborador, setCodColaborador] = useState(() => {
    return localStorage.getItem('codcolaborador') ? parseInt(localStorage.getItem('codcolaborador')) : 0;
  });

  const [isGestor, setIsGestor] = useState(() => {
    return localStorage.getItem('isGestor') ? localStorage.getItem('isGestor') : false;
  });

  const [fotoPerfil, setFotoPerfil] = useState(() => {
    return localStorage.getItem('fotoPerfil') ? localStorage.getItem('fotoPerfil') : "";
  });

  const [nomeDoColaborador, setNomeDoColaborador] = useState(() => {
    return localStorage.getItem('nomeDoColaborador') ? localStorage.getItem('nomeDoColaborador') : "";
  });

  // Atualiza o estado e armazena os dados no localStorage ao fazer login
  const updateLoginData = (data, key) => {
    setCompanies(data);
    setAccessKey(key);
    localStorage.setItem('companies', JSON.stringify(data));
    localStorage.setItem('accessKey', key);
  };

  // Atualiza o localStorage sempre que selectedCompany ou codassinante forem alterados
  useEffect(() => {
    localStorage.setItem('selectedCompany', selectedCompany);
  }, [selectedCompany]);

  useEffect(() => {
    localStorage.setItem('codassinante', codassinante);
  }, [codassinante]);

  useEffect(() => {
    localStorage.setItem('codcolaborador', codcolaborador);
    localStorage.setItem('isGestor', isGestor);
    localStorage.setItem('accessKey', accessKey);
    localStorage.setItem('nomeDoColaborador', nomeDoColaborador);
    localStorage.setItem('fotoPerfil', fotoPerfil);
  }, [codcolaborador]);

  return (
    <AppContext.Provider
      value={{
        companies,
        accessKey,
        selectedCompany,
        codassinante,
        codcolaborador,
        isGestor,
        nomeDoColaborador,
        fotoPerfil,
        setNomeDoColaborador,
        setAccessKey,
        setSelectedCompany,
        setCodAssinante,
        setCodColaborador,
        setIsGestor,
        setFotoPerfil,
        updateLoginData,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
